
import { defineComponent, ref, Ref, onMounted, inject, computed } from "vue";
import CloseSVG from "@/components/CloseSVG.vue";
import useSaveAndContinue from "@/composables/useSaveAndContinue";
import { getEditorUrlParam } from "@/composables/useParseURL";
import { store } from "@/store";

export default defineComponent({
  name: "ConfirmBack",
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const loading = ref<boolean>(false);
    const backUrl = window.document.referrer;
    const artworkName = ref<string>('Design 1');

    if (store.getters.userArtworkFetch.artwork && Object.keys(store.getters.userArtworkFetch.artwork).length)
      artworkName.value = store.getters.userArtworkFetch.artwork.title;

    const goBack = async (save = false) => {
        loading.value = true;
        if (save) {
            loading.value = await useSaveAndContinue({
                title: artworkName.value,
                noRedirect: true,
            });
        }
        
        window.location.href = backUrl;
    }

    const title = ref("");
    onMounted(() => {
      //Trigger rerender on mount
      title.value = "Save your changes?";
    });

    return {
      closeModal,
      fadeTransition,
      bounceTransition,
      loading,
      title,
      artworkName,
      goBack,
    };
  },
});
